import arcGisConnection, { ArcGisConnection } from './arcgis-connection';

export type ConnectionConstructor = (
  esriApiKey: string,
  connectors: any[],
  connectionConstructor: ConnectionConstructor
) => { any }

export const checkConnectionSignInStatus = async (connection) => {
  const status = await connection.checkSignInStatus();
  return status;
};

export const checkForSignedInConnection = async (
  esriApiKey: string,
  connectors: any[],
  onlineOnly: boolean,
  connectionConstructor: ArcGisConnection | undefined = undefined,
) => {
  const constructor = connectionConstructor || arcGisConnection;
  const onlineConnection = constructor(esriApiKey);
  const status = await checkConnectionSignInStatus(onlineConnection);

  if (status) {
    return onlineConnection;
  }

  if (onlineOnly) {
    return undefined;
  }

  const esriEnterpriseConnectors = connectors.filter((connector) => connector.connector_type === 'esriEnterprise');

  const checkConnection = async (connector) => {
    const parsedData = JSON.parse(connector.data);
    const newConnection = constructor(esriApiKey, parsedData.appId, parsedData.portalUrl);
    return (await checkConnectionSignInStatus(newConnection)) ? newConnection : null;
  };

  const connectedConnection = await Promise.all(esriEnterpriseConnectors.map(checkConnection))
    .then((results) => results.find((result) => result !== null));

  if (connectedConnection) {
    return connectedConnection;
  }
  return undefined;
};
